import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReactPaginate from 'react-paginate';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Form, Menu, Table } from 'semantic-ui-react';
import { DataNotFound } from '../../../../../components/DataNotFound';
import { downloadCSV } from '../../../../../components/helper/downloadCSVHelper';
import { deleteAsync, getAsync, postAsync, putAsync } from '../../../../../components/helper/axiosHelper';
import { useLocation } from 'react-use';
import { PageHitCountApi } from '../../../../../shared/Helper';
import {
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalFooter,
  MDBModalHeader,
  MDBModalTitle,
} from 'mdb-react-ui-kit';
import moment from 'moment';
import LoadingAnimation from '../../../../../components/LoadingAnimation';
import SearchFilters from '../../../../../components/elements/SearchFilter';
import VideogalleryModal from '../VideogalleryModal';
import DatePickerLayout from '../../../../../components/elements/DatePicker';
import 'react-datepicker/dist/react-datepicker.css';
import { validateFields } from '../../../../../utils/validation';
import { printTable } from '../../../../../utils/tableExportUtils';

export default function ReadVideoGallery() {
  const isActive = useSelector((state) => state.toggle.isActive);
  const [apiData, setApiData] = useState([]);
  const [title, setTitle] = useState('');
  const [titleEn, setTitleEn] = useState('');
  const [publicationDate, setPublicationDate] = useState('');
  const [filmingLocation, setFilmingLocation] = useState([]);
  const [filmlocation, setFilmlocation] = useState('');
  const [keywords, setKeywords] = useState('');
  const [link, setLink] = useState('');
  const [userID, setUserId] = useState(0);
  const [gridModalcreate, setGridModalcreate] = useState(false);
  const [gridModalupdate, setGridModalupdate] = useState(false);
  const [pageCount, setPageCount] = useState(1);
  const [isLoad, setIsLoad] = useState(false);
  const [datanotfound, setDatanotfound] = useState(false);
  const [next, setNext] = useState(1);
  const [recordID, setRecordID] = useState(null);
  const [pageOptions, setPageOptions] = useState({
    pageNo: 1,
    pageSize: 20,
  });
  const [dateTo, setDateTo] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [searchTitle, setSearchTitle] = useState('');

  const toggleShowCreate = () => {
    setGridModalcreate(!gridModalcreate);
    setTitleEn('');
    setTitle('');
    setPublicationDate('');
    setFilmlocation('');
    setKeywords('');
    setLink('');
  };
  const toggleShowUpdate = () => setGridModalupdate(!gridModalupdate);

  const navigate = useNavigate();
  const { t } = useTranslation();
  const token = localStorage.getItem('token');
  const epUser = localStorage.getItem('apid');
  const todayDate = new Date();
  const { pathname } = useLocation()

  const isLogin = () => {
    if (!token) {
      navigate('/managementLogin');
    }
  };

  const isValidVideoLink = (url) => {
    const videoRegex = /\.(mp4|webm|ogg)$/i; // direct video file
    const youtubeRegex = /^(https?\:\/\/)?(www\.youtube\.com|youtu\.?be)\/.+$/;
    const vimeoRegex = /^(https?\:\/\/)?(www\.)?vimeo\.com\/.+$/;

    return videoRegex.test(url) || youtubeRegex.test(url) || vimeoRegex.test(url);
  };

  useEffect(() => {
    const adminID = localStorage.getItem('apid');
    if (adminID) {
      PageHitCountApi(pathname, adminID);
    }
  }, [])


  const Createbody = {
    title,
    titleEn,
    publicationDate,
    filmingLocation: isActive ? filmingLocation?.ar_SA : filmingLocation?.en_US,
    keywords,
    link,
    userID: parseInt(epUser),
  };

  let axiosConfig = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  const bodyGet = {
    epUserID: parseInt(epUser),
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const isValid = validateFields(
      [
        { value: title, labelKey: 'cms_title' },
        { value: titleEn, labelKey: 'Title En' },
        { value: publicationDate, labelKey: 'cms_publicationDate' },
        { value: keywords, labelKey: 'cms_keywords' },
        { value: link, labelKey: 'cms_link' }
      ],
      t
    );

    if (!isValid) return;
    if (!isValidVideoLink(link)) {
      toast.error(t('Please enter a valid video link.'));
      return;
    }

    try {
      const response = await postAsync('CMSVideoGallery/CreateCMSVideoGallery', Createbody, {
        headers: {
          Authorization: `Bearer ${token}`,
          axiosConfig,
        },
      });

      if (response?.statusCode === 200) {
        toast.success(`${t('Created Successfully')}`);
        setTitleEn('');
        setTitle('');
        setPublicationDate('');
        setFilmlocation('');
        setKeywords('');
        setLink('');
        getData();
        setDatanotfound(false);
        toggleShowCreate(e);
      }
    } catch (err) {
      toast.error(t('Something went wrong, Please try again!'));
    }
  };
  const getDataByID = async (Id) => {
    try {
      const response = await getAsync(`CMSVideoGallery/GetByIdCMSVideoGallery`, {
        id: Id,
      });
      if (response?.data && response?.data.length > 0) {
        const data = response?.data[0];
        setTitle(data?.title);
        const date = data?.publicationDate.split('/');
        const formateddate = `${date[2]}-${date[1]}-${date[0]}`;
        setPublicationDate(formateddate);
        setKeywords(data?.keywords);
        setLink(data?.link);
        setFilmlocation(data?.filmingLocation);
        setUserId(data?.userID);
        setTitleEn(data?.titleEn);

        // toast.info(response?.data?.message);
      } else {
        toast.error(t('Record Not Found.'));
      }
    } catch (err) {
      console.error(err);
      toast.error(t('Something went wrong, Please try again!'));
    }
  };

  const updateRecordById = (e, id) => {
    e.preventDefault();
    toggleShowUpdate();
    getDataByID(id);
    setRecordID(id);
  };

  const Updatebody = {
    title,
    titleEn,
    publicationDate,
    filmingLocation: isActive ? filmingLocation?.ar_SA : filmingLocation?.en_US,
    keywords,
    link,
    userID,
  };

  const SearchFilter = {
    // epUserID: epUser,
    dateFrom: moment(dateFrom).format('DD/MM/YYYY'),
    dateTo: moment(dateTo).format('DD/MM/YYYY'),
    cmsTitle: searchTitle,
  };

  const SearchRecord = async () => {
    try {
      setIsLoad(true);
      setDatanotfound(false);
      const response = await postAsync(
        `CMSVideoGallery/GetCMSVideoGalleryFilterList/${pageOptions.pageNo}/${pageOptions.pageSize}`,
        SearchFilter,
      );
      if (response) {
        setIsLoad(false);
        setApiData(response?.data);
        setPageCount(response.page);
        setNext(pageOptions.pageNo);
      }
      if (response?.statusCode == 204) {
        setDatanotfound(true);
      }
    } catch (err) {
      console.log(err);
      toast.error(t('Something went wrong, Please try again!'));
    }
  };

  const onUpdate = async (id) => {
    const isValid = validateFields(
      [
        { value: title, labelKey: 'cms_title' },
        { value: titleEn, labelKey: 'Title En' },
        { value: publicationDate, labelKey: 'cms_publicationDate' },
        { value: keywords, labelKey: 'cms_keywords' },
        { value: link, labelKey: 'cms_link' },
      ],
      t,
    );

    if (!isValid) return;
    if (!isValidVideoLink(link)) {
      toast.error(t('Please enter a valid video link (YouTube, Vimeo, or .mp4 etc)'));
      return;
    }

    try {
      const response = await putAsync('CMSVideoGallery/UpdateCMSVideoGallery', Updatebody, {
        id: id,
      });

      if (response?.statusCode === 200) {
        toast.success(`${t('Updated Successfully')}`);
        getData();
        toggleShowUpdate();
        // navigate('/readVideoGallery');
      }
    } catch (err) {
      toast.error(t('Something went wrong, Please try again!'));
    }
  };
  const getData = async () => {
    setIsLoad(true);
    await postAsync(
      'CMSVideoGallery/GetCMSVideoGalleryFilterList/' + pageOptions.pageNo + '/' + pageOptions.pageSize,
      {},
      'application/json',
    )
      .then((response) => {
        setIsLoad(false);
        setApiData(response?.data);
        setPageCount(response?.page);
        if (response?.statusCode == 204) {
          setDatanotfound(true);
        }
        setNext(pageOptions.pageNo);
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  useEffect(() => {
    localStorage.setItem('isHome', false);
    isLogin();
    getData();
    (async function () {
      try {
        const response = await getAsync('Utilities/GetCountryList');

        setFilmingLocation(response?.data[0]);
      } catch (error) {
        console.log(error);
      }
    })();
  }, []);

  const handleOnSelectCountry = (selectedCountry) => {
    const id = selectedCountry.target.value;
    setFilmlocation(id);
  };

  const onDelete = async (e, id) => {
    e.preventDefault();
    await deleteAsync('CMSVideoGallery/DeleteCMSVideoGallery', {
      id: id,
    })
      .then((response) => {
        if (response?.statusCode === 200) {
          setApiData(response?.data);
          toast.success(`${t('Deleted Successfully')}`);
          getData();
        }
      })
      .catch((err) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };
 
  const changePage = async ({ selected }) => {
    const select = selected + 1;

    await postAsync('CMSVideoGallery/GetCMSVideoGalleryFilterList/' + select + '/' + pageOptions.pageSize, bodyGet)
      .then((response) => {
        setApiData(response?.data);
        setPageCount(response?.page);
        setNext(selected + 1);
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('Something went wrong, Please try again!'));
      });
  };
  // Export xlsl file
  const handleOnExport = () => {

    const filteredData = apiData?.map((item, ii) => ({
      'S.No': ii + 1,
      'Title': isActive ? item.title: item.titleEn,
      'Publication Date': item.publicationDate,
      'Filming Location': item.filmingLocation ? item.filmingLocation : 'N/A',
      'Keywords': item.keywords,
      'Video Link': item.link,
    }));
    downloadCSV(filteredData, 'Read Success Story');
  };

  // const handlePrint = (e) => {
  //   e.preventDefault();
  //   const tableContainer = document.createElement('div');
  //   tableContainer.className = 'tableData my-4';

  //   // Create and add the heading
  //   const heading = document.createElement('h1');
  //   heading.className = 'font-bold text-center my-8 sm:text-2xl text-xl text-customgreen';
  //   heading.innerText = `${t('Video Gallery List')}`; // Replace with your desired heading text
  //   tableContainer.appendChild(heading);

  //   const table = document.createElement('table');
  //   table.innerHTML = `
  //   <thead style="background-color: #2f855a; color: white;">

  //     <tr>
  //       <th style="padding: 5px; border: 1px solid #ddd;">#</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t('cms_title')}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`cms_publicationDate`)}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t('cms_filmingLocation')}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`cms_keywords`)}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t('Video Link')}</th>
  //     </tr>
  //   </thead>
  //   <tbody>
  //     ${apiData
  //       .map(
  //         (data, index) => `
  //           <tr style="background-color: ${index % 2 === 0 ? '#f9f9f9' : '#fff'}; border: 1px solid #ddd;">
  //             <td style="padding: 5px; border: 1px solid #ddd;">${index + 1}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${isActive ? data?.title || '' : data?.titleEn || ''}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${data?.publicationDate}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${data.filmingLocation ? data.filmingLocation : 'N/A'}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${data?.keywords || 'N/A'}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${data?.link ? data?.link : 'N/A'}</td>
  //           </tr>
  //         `,
  //       )
  //       .join('')}
  //   </tbody>
  // `;

  //   tableContainer.appendChild(table);
  //   document.body.appendChild(tableContainer);

  //   // Add CSS to hide everything except the table when printing
  //   const style = document.createElement('style');
  //   style.textContent = `
  //   @media print {

  //     body * {
  //       visibility: hidden;
  //       height: 0;

  //     }
  //     .tableData, .tableData * {
  //       visibility: visible;
  //     }
  //     .tableData {
  //       position: absolute;
  //       left: 0;
  //       top: 0;
  //       width: 100%;
  //       height: auto;
  //       overflow: visible;
  //     }
  //   }
  // `;
  //   document.head.appendChild(style);

  //   // Trigger the print dialog
  //   window.print();

  //   // Clean up by removing the table container and style from the DOM
  //   document.body.removeChild(tableContainer);
  //   document.head.removeChild(style);

  //   return 'success';
  // };
const handlePrint = (e) => {
  e.preventDefault();
  
  // Column configuration
  const columns = [
    {
      header: t('sNo'),
      accessor: (row, index) => index + 1
    },
    {
      header: t('cms_title'),
      accessor: (row) => isActive ? row?.title : row?.titleEn
    },   {
      header: t('cms_publicationDate'),
      accessor: (row) => isActive ? row?.publicationDate  || 'N/A' : row?.publicationDate  || 'N/A'
    },
    ,   {
      header: t('cms_filmingLocation'),
      accessor: (row) => isActive ? row?.filmingLocation  || 'N/A' : row?.filmingLocation  || 'N/A'
    },  
    {
      header: t('cms_keywords'),
      accessor: (row) => row?.keywords || 'N/A'
    },
    {
      header: t('Video Link'),
      accessor: (row) => isActive ? row?.link  || 'N/A' : row?.link || 'N/A'
    }

  ];
  
  // Call the reusable print function
  printTable({
    data: apiData || [],
    isRTL: isActive, // isActive true = Arabic = RTL
    t: t,
    title: `${t('Video Gallery List')} `,
    columns: columns,
    onBeforePrint: () => {
      console.log('Printing started...');
      // toast.info(t('Preparing print preview...'));
    },
    onAfterPrint: () => {
      console.log('Printing completed');
    },
    styles: {
      customCSS: `
        /* Additional custom styles if needed */
        .print-table th {
          font-weight: 600;
        }
        @media print {
          .print-title {
            color: #000 !important;
          }
        }
      `
    }
  });
};
  return (
    <div className="">
      {!isLogin ? (
        <h1>{t('Not Authorized')}</h1>
      ) : (
        <>
          <div className="container-fluid ">
            {/* <div className="row justify-center">
              <div className="col-lg-11 text-center">
                <h3 className="font-bold sm:text-2xl  text-xl text-customgreen">
                  {t('cms_videoGallery')} {t('list')}
                </h3>
              </div>
            </div> */}
            <div className="row text-center">
              <div className="col-lg-11 flex justify-end my-4">
                <button
                  className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center"
                  onClick={toggleShowCreate}
                >
                  {t('create')}
                </button>
              </div>
            </div>

            <div className="row justify-center flex-row">
              <SearchFilters
                handleSearch={SearchRecord}
                setDateFrom={setDateFrom}
                setDateTo={setDateTo}
                dateTo={dateTo}
                dateFrom={dateFrom}
                handlePrint={handlePrint}
                handleOnExport={handleOnExport}
                heading={'cms_videoGallery'}
                isTitleVisible={true}
                setSearchTitle={setSearchTitle}
                isApplicantName={false}
              />
            </div>

            {/* Modal Create */}
            <>
              <MDBModal tabIndex="-1" show={gridModalcreate} setShow={setGridModalcreate}>
                <MDBModalDialog className="flex justify-center items-center">
                  <MDBModalContent className="w-auto bg-green-50 sm:w-[50vw] md:w-[80vw] lg:w-[100vw]">
                    <Form className="flex sm:max-w-[50vw] md:max-w-[60vw] lg:w-[60vw]  flex-col justify-center items-center">
                      <MDBModalHeader>
                        <MDBModalTitle className="text-customgreen font-semibold">
                          {t('create')} {t('cms_videoGallery')}
                        </MDBModalTitle>
                        {/* <MDBBtn type="button" className="btn-close" color="none" onClick={toggleShowCreate}></MDBBtn> */}
                      </MDBModalHeader>
                      <MDBModalBody>
                        <div className="container-fluid bd-example-row">
                          <div className="row" style={{ marginBottom: '10px' }}>
                            <div className="col-md-6 col-example">
                              <Form.Field>
                                <label className="mx-auto text-customgreen">{t('cms_title')} : </label>
                                <input
                                  type="text"
                                  name="title"
                                  value={title}
                                  className="  border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                                  onChange={(e) => setTitle(e.target.value)}
                                  placeholder={t('cms_title')}
                                />
                              </Form.Field>
                            </div>
                            <div className="col-md-6 col-example">
                              <Form.Field>
                                <label className="mx-auto text-customgreen">{t('Title En')} : </label>
                                <input
                                  type="text"
                                  name="title"
                                  value={titleEn}
                                  className="  border w-full border-gray-300 text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                                  onChange={(e) => setTitleEn(e.target.value)}
                                  placeholder={t('Title En')}
                                />
                              </Form.Field>
                            </div>
                          </div>
                          <div className="row" style={{ marginBottom: '10px' }}>
                            <div className="col-md-6 form-group flex flex-col">
                              <DatePickerLayout
                                label={'cms_publicationDate'}
                                selectedDate={publicationDate}
                                keyValue={'to'}
                                dateTo={publicationDate}
                                setDateTo={setPublicationDate}
                                maxDate={todayDate}
                              />
                              {/* </div> */}
                            </div>
                            <div className="col-md-6 ms-auto col-example">
                              <Form.Field>
                                <label className="mx-auto text-customgreen">{t('cms_keywords')} : </label>
                                <input
                                  type="text"
                                  name="keywords"
                                  value={keywords}
                                  onChange={(e) => setKeywords(e.target.value)}
                                  className="  border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                                  placeholder={t('cms_keywords')}
                                />
                              </Form.Field>
                            </div>
                          </div>
                          <div className="row" style={{ marginBottom: '10px' }}>
                            <div className="col-md-6 ms-auto col-example">
                              <Form.Field>
                                <label className="mx-auto text-customgreen">{t('cms_filmingLocation')} : </label>

                                <input
                                  type="text"
                                  disabled
                                  name="filmLocation"
                                  value={isActive ? filmingLocation?.ar_SA : filmingLocation?.en_US}
                                  className=" border w-full border-gray-300 text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  cursor-not-allowed"
                                  // onChange={(selectedCountry) => handleOnSelectCountry(selectedCountry)}
                                  placeholder={t('cms_filmingLocation')}
                                />
                                {/* <select
                                  name="filmLocation"
                                  value={filmlocation}
                                  required
                                  className="  border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                                  onChange={(selectedCountry) => handleOnSelectCountry(selectedCountry)}
                                  placeholder={t('cms_filmingLocation')}
                                >
                                  <option value={0}>--{t('Select Country')}--</option>
                                  {filmingLocation && filmingLocation.length > 0 ? (
                                    filmingLocation?.map((item) => {
                                      return (
                                        <option key={item.countryID} value={item?.countryName}>
                                          {isActive ? item?.ar_SA : item?.countryName}
                                        </option>
                                      );
                                    })
                                  ) : (
                                    <option>{t('Select country')}</option>
                                  )}
                                </select> */}
                              </Form.Field>
                            </div>

                            <div className="col-md-6 ms-auto col-example">
                              <Form.Field>
                                <label className="mx-auto text-customgreen">{t('Video Link')} : </label>
                                <input
                                  type="text"
                                  name="link"
                                  value={link}
                                  className="  border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                                  onChange={(e) => setLink(e.target.value)}
                                  placeholder={t('cms_link')}
                                />
                              </Form.Field>
                            </div>
                          </div>
                        </div>
                      </MDBModalBody>
                      <MDBModalFooter className="flex justify-center">
                        <button
                          className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center "
                          onClick={(e) => {
                            onSubmit(e);
                          }}
                        >
                          {t('create')}
                        </button>
                        <button
                          className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center"
                          onClick={toggleShowCreate}
                        >
                          {t('close')}
                        </button>
                      </MDBModalFooter>
                    </Form>
                  </MDBModalContent>
                </MDBModalDialog>
              </MDBModal>
            </>
            {/* end */}
            {/* Modal Update */}
            <>
              <VideogalleryModal
                updateRecordById={updateRecordById}
                t={t}
                gridModalupdate={gridModalupdate}
                setGridModalupdate={setGridModalupdate}
                recordID={recordID}
                title={title}
                setTitleEn={setTitleEn}
                titleEn={titleEn}
                setTitle={setTitle}
                publicationDate={publicationDate}
                setPublicationDate={setPublicationDate}
                filmlocation={filmlocation}
                handleOnSelectCountry={handleOnSelectCountry}
                filmingLocation={filmingLocation}
                keywords={keywords}
                setKeywords={setKeywords}
                // showPreview={showPreview}
                //applyErrorClass={applyErrorClass}
                link={link}
                //values={values}
                // doc={doc}
                setLink={setLink}
                onUpdate={onUpdate}
                // onChange={handleFileInputChange}
              />
            </>
            {/* end */}
            <div className="pb-5  row justify-center ">
              {isLoad ? (
                <LoadingAnimation />
              ) : (
                <div className="col-lg-11 text-center pt-9">
                  <div class="relative overflow-x-auto  shadow-md sm:rounded-lg">
                    <Table className="text-sm tableData text-left rtl:text-right ">
                      <Table.Header className="font-bold text-white whitespace-nowrap  bg-customgreen uppercase">
                        <Table.Row>
                          <Table.HeaderCell className="text-white">{t('sNo')}</Table.HeaderCell>
                          <Table.HeaderCell className="text-white">{t('cms_title')}</Table.HeaderCell>
                          <Table.HeaderCell className="text-white">{t('cms_publicationDate')}</Table.HeaderCell>
                          <Table.HeaderCell className="text-white">{t('cms_filmingLocation')}</Table.HeaderCell>
                          <Table.HeaderCell className="text-white">{t('cms_keywords')}</Table.HeaderCell>
                          <Table.HeaderCell className="text-white">{t('Video Link')}</Table.HeaderCell>
                          <Table.HeaderCell className="text-white">{t('Action')}</Table.HeaderCell>
                          <Table.HeaderCell className="text-white">{t('')}</Table.HeaderCell>
                        </Table.Row>
                      </Table.Header>

                      <Table.Body className=".tableData">
                        {apiData?.map((data, index) => {
                          const sno = (next - 1) * pageOptions.pageSize + index + 1;

                          return (
                            <Table.Row className="text-sm" key={index}>
                              <Table.Cell>{sno}</Table.Cell>
                              <Table.Cell>{isActive ? data?.title : data?.titleEn}</Table.Cell>
                              <Table.Cell>{data.publicationDate}</Table.Cell>
                              <Table.Cell>{data.filmingLocation ? data.filmingLocation : 'N/A'}</Table.Cell>
                              <Table.Cell>{data.keywords}</Table.Cell>
                              <Table.Cell>{data?.link ? data?.link : 'N/A'}</Table.Cell>
                              <Table.Cell>
                                <button
                                  className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center "
                                  type="button"
                                  onClick={(e) => {
                                    updateRecordById(e, data?.videoGalleryID);
                                    setGridModalupdate(true);
                                  }}
                                >
                                  {t('Update')}
                                </button>
                              </Table.Cell>
                              <Table.Cell>
                                <button
                                  className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center"
                                  onClick={(e) => onDelete(e, data.videoGalleryID)}
                                >
                                  {t('delete')}
                                </button>
                              </Table.Cell>
                            </Table.Row>
                          );
                        })}
                      </Table.Body>
                    </Table>
                    {datanotfound && <DataNotFound />}
                  </div>
                  {pageCount > 0 && (
                    <div className="flex flex-row px-12 justify-between">
                      <Menu pagination>
                        <Menu.Item>
                          <ReactPaginate
                            previousLabel={t('Previous')}
                            nextLabel={t('Next')}
                            pageCount={pageCount}
                            onPageChange={changePage}
                            containerClassName={'paginationButtons'}
                            previousLinkClassName={'previousButton'}
                            nextLinkClassName={'nextButton'}
                            disabledClassName={'paginationDisabled'}
                            activeClassName={'paginationActive'}
                          />
                        </Menu.Item>
                      </Menu>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
